const initialState = {
  timeSlots: [
  {
    startTimeFmt: '11:45 AM'
  },
  {
    startTimeFmt: '12:00 PM'
  },
  {
    startTimeFmt: '12:15 PM'
  },
  {
    startTimeFmt: '12:30 PM'
  },
  {
    startTimeFmt: '12:45 PM'
  },
  {
    startTimeFmt: '1:00 PM'
  },
  {
    startTimeFmt: '1:15 AM'
  },
  {
    startTimeFmt: '1:30 AM'
  },
  {
    startTimeFmt: '1:45 AM'
  },
  {
    startTimeFmt: '2:00 AM'
  },
  {
    startTimeFmt: '2:15 PM'
  },
  {
    startTimeFmt: '2:30 PM'
  },
  {
    startTimeFmt: '2:45 PM'
  },
  {
    startTimeFmt: '3:00 PM'
  }
]
}

export default initialState;
